import * as S from './style'
import { FailIcon } from '../../assets/images/icons'

const ByePage = () => {
  const supportLink =
    window.location.href.indexOf('maggiortutela') > -1
      ? process.env.REACT_APP_LINK_MERCATO_TUTELATO
      : process.env.REACT_APP_LINK_MERCATO_LIBERO
  return (
    <S.ByePageWrapper>
      <S.ByePageIconContainer>
        <FailIcon isDark={window.location.href.indexOf('maggiortutela') > -1} />
      </S.ByePageIconContainer>
      <S.ByePageTitleContainer>
        <strong>Accesso fallito!</strong>
      </S.ByePageTitleContainer>
      <S.ByePageSubtitleContainer>
        Siamo spiacenti, ma in questo momento non puoi proseguire con la login.
        Ti invitiamo a riprovare più tardi.
        <br />
        Se riscontri ancora problemi puoi contattare il{' '}
        <a href={supportLink}>servizio clienti</a>
      </S.ByePageSubtitleContainer>
    </S.ByePageWrapper>
  )
}

export default ByePage
